import { render, staticRenderFns } from "./GuppyFileMessage.vue?vue&type=template&id=07714d7e&"
import script from "./GuppyFileMessage.vue?vue&type=script&lang=js&"
export * from "./GuppyFileMessage.vue?vue&type=script&lang=js&"
import style0 from "./GuppyFileMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports